export default () => {
    let gradient = document.querySelector(".text-gradient");

    if (gradient && !hasBackgroundClip()) {
        let text = gradient.innerText;
        let page = document.querySelector('body').getAttribute('id');

        gradient.innerHTML = "";
        gradient.setAttribute(
            "style",
            "background-image: none !important;"
        );
        let svgGradient = document.createElement("img");
        addAttributes(svgGradient, {
            src: `/images/${page}-gradient.svg`,
            alt: `${text}`,
        });

        gradient.appendChild(svgGradient);
    }

    function addAttributes(el, attributes) {
        for (var key in attributes) {
            el.setAttribute(key, attributes[key]);
        }
    }

    function hasBackgroundClip() {
        return document.body.style.webkitBackgroundClip != undefined;
    }
};
